var Filemanager = require('./Filemanager');
var fmModul = require('./integration/fmModul');

var $ = require('jquery');

exports.init = function() {
    diy.core.namespace('diy.editor').Filemanager = Filemanager;

    window.onImageManagementLiveEditResourceUpdated = function() {
        if (diy.editor.filemanager) {
            diy.editor.filemanager.reload();
        }
    };

    // Live editing code support
    jQuery(window).bind('fb-flo-reload', function(ev) {
        if (!/\.css$/.test(ev.originalEvent.data.url)) {
            window.onImageManagementLiveEditResourceUpdated();
        }
    });

    $(function() {
        fmModul.init();
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/init.js
 ** module id = 930
 ** module chunks = 0
 **/